import { render } from "./setupPassword.vue?vue&type=template&id=6283a48a&scoped=true"
import script from "./setupPassword.vue?vue&type=script&lang=js"
export * from "./setupPassword.vue?vue&type=script&lang=js"

import "./setupPassword.vue?vue&type=style&index=0&id=6283a48a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6283a48a"]])

export default __exports__